
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/tooltip",
      function () {
        return require("private-next-pages/components/tooltip.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/tooltip"])
      });
    }
  